webpackJsonp([18,16],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _keys = __webpack_require__(91);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _vue = __webpack_require__(89);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(383);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _webpackZepto = __webpack_require__(20);
	
	var _webpackZepto2 = _interopRequireDefault(_webpackZepto);
	
	var _elementUi = __webpack_require__(178);
	
	var _elementUi2 = _interopRequireDefault(_elementUi);
	
	__webpack_require__(181);
	
	var _nprogress = __webpack_require__(3);
	
	var _nprogress2 = _interopRequireDefault(_nprogress);
	
	__webpack_require__(182);
	
	var _vueRouter = __webpack_require__(403);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _filters = __webpack_require__(148);
	
	var _filters2 = _interopRequireDefault(_filters);
	
	var _routers = __webpack_require__(151);
	
	var _routers2 = _interopRequireDefault(_routers);
	
	var _alert = __webpack_require__(149);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	var _user = __webpack_require__(90);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _fastclick = __webpack_require__(199);
	
	var _fastclick2 = _interopRequireDefault(_fastclick);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_alert2.default);
	_vue2.default.use(_elementUi2.default);
	
	_webpackZepto2.default.ajaxSettings.crossDomain = true;
	
	_nprogress2.default.configure({ showSpinner: false });
	// 实例化Vue的filter
	(0, _keys2.default)(_filters2.default).forEach(function (k) {
	    return _vue2.default.filter(k, _filters2.default[k]);
	});
	
	// 实例化VueRouter
	var router = new _vueRouter2.default({
	    mode: 'history',
	    routes: _routers2.default
	});
	_fastclick2.default.attach(document.body);
	
	// 处理刷新的时候vuex被清空但是用户已经登录的情况
	if (window.sessionStorage.user) {
	    _user2.default.dispatch('setUserInfo', JSON.parse(window.sessionStorage.user));
	}
	
	// 登录中间验证，页面需要登录而没有登录的情况直接跳转登录
	router.beforeEach(function (to, from, next) {
	    // 处理左侧滚动不影响右边
	    (0, _webpackZepto2.default)('html, body, #page').removeClass('scroll-hide');
	    if (to.matched.some(function (record) {
	        return record.meta.requiresAuth;
	    })) {
	        if (_user2.default.state.userInfo.userId) {
	            next();
	        } else {
	            next({
	                path: '/login',
	                query: { redirect: to.fullPath }
	            });
	        }
	    } else {
	        next();
	    }
	});
	
	new _vue2.default({
	    router: router,
	    store: _user2.default,
	    render: function render(h) {
	        return h(_App2.default);
	    }
	}).$mount('#app');

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _lodash = __webpack_require__(200);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _timeago = __webpack_require__(382);
	
	var _timeago2 = _interopRequireDefault(_timeago);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getCheck = {
	    checkEmail: function checkEmail(val) {
	        var filter = /^([a-zA-Z0-9_\\.\\-])+\\@(([a-zA-Z0-9\\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
	        if (filter.test(val)) {
	            return true;
	        } else {
	            return false;
	        }
	    },
	    checkPhone: function checkPhone(val) {
	        var filter = /^1\d{10}$/;
	
	        if (filter.test(val)) {
	            return true;
	        } else {
	            return false;
	        }
	    }
	};
	
	/**
	 * 从文本中提取出@username 标记的用户名数组
	 * @param {String} text 文本内容
	 * @return {Array} 用户名数组
	 */
	var fetchUsers = function fetchUsers(text) {
	    if (!text) {
	        return [];
	    }
	
	    var ignoreRegexs = [/```.+?```/g, // 去除单行的 ```
	    /^```[\s\S]+?^```/gm, // ``` 里面的是 pre 标签内容
	    /`[\s\S]+?`/g, // 同一行中，`some code` 中内容也不该被解析
	    /^.*/gm, // 4个空格也是 pre 标签，在这里 . 不会匹配换行
	    /\b\S*?@[^\s]*?\..+?\b/g, // somebody@gmail.com 会被去除
	    /\[@.+?\\]\(\/.+?\)/g // 已经被 link 的 username
	    ];
	
	    ignoreRegexs.forEach(function (ignoreRegex) {
	        text = text.replace(ignoreRegex, '');
	    });
	
	    var results = text.match(/@[a-z0-9\-_]+\b/igm);
	    var names = [];
	    if (results) {
	        for (var i = 0, l = results.length; i < l; i++) {
	            var s = results[i];
	            // remove leading char @
	            s = s.slice(1);
	            names.push(s);
	        }
	    }
	    names = _lodash2.default.uniq(names);
	    return names;
	};
	
	/**
	 * 根据文本内容，替换为数据库中的数据
	 * @param {String} text 文本内容
	 * @param {Function} callback 回调函数
	 */
	var linkUsers = function linkUsers(text) {
	    var users = fetchUsers(text);
	    for (var i = 0, l = users.length; i < l; i++) {
	        var name = users[i];
	        text = text.replace(new RegExp('@' + name + '\\b(?!\\])', 'g'), '[@' + name + '](/user/' + name + ')');
	    }
	    return text;
	};
	
	/**
	 *   对Date的扩展，将 Date 转化为指定格式的String
	 *   月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
	 *   年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
	 *   例子：
	 *   (new Date()).Format('yyyy-MM-dd hh:mm:ss.S') ==> 2006-07-02 08:09:04.423
	 *   (new Date()).Format('yyyy-M-d h:m:s.S')      ==> 2006-7-2 8:9:4.18
	 */
	var fmtDate = function fmtDate(date, fmt) {
	    // author: meizz
	    var o = {
	        'M+': date.getMonth() + 1, // 月份
	        'd+': date.getDate(), // 日
	        'h+': date.getHours(), // 小时
	        'm+': date.getMinutes(), // 分
	        's+': date.getSeconds(), // 秒
	        'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
	        'S': date.getMilliseconds() // 毫秒
	    };
	    if (/(y+)/.test(fmt)) {
	        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
	    }
	    for (var k in o) {
	        if (new RegExp('(' + k + ')').test(fmt)) {
	            fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
	        }
	    }
	    return fmt;
	};
	var parseDate = function parseDate(str) {
	    return new Date(Date.parse(str));
	};
	var getAge = function getAge(birthDate) {
	    var returnAge;
	    var birth = new Date(birthDate);
	    var birthYear = birth.getFullYear();
	    var birthMonth = birth.getMonth() + 1;
	    var birthDay = birth.getDate();
	    var d = new Date();
	    var nowYear = d.getFullYear();
	    var nowMonth = d.getMonth() + 1;
	    var nowDay = d.getDate();
	
	    if (nowYear === birthYear) {
	        returnAge = 0;
	    } else {
	        var ageDiff = nowYear - birthYear;
	        if (ageDiff > 0) {
	            if (nowMonth === birthMonth) {
	                var dayDiff = nowDay - birthDay;
	                if (dayDiff < 0) {
	                    returnAge = ageDiff - 1;
	                } else {
	                    returnAge = ageDiff;
	                }
	            } else {
	                var monthDiff = nowMonth - birthMonth;
	                if (monthDiff < 0) {
	                    returnAge = ageDiff - 1;
	                } else {
	                    returnAge = ageDiff;
	                }
	            }
	        } else {
	            returnAge = -1;
	        }
	    }
	    return returnAge;
	};
	/**
	 * 调用Timeago库显示到现在的时间
	 */
	var MillisecondToDate = function MillisecondToDate(time) {
	    var str = '';
	    if (time !== null && time !== '') {
	        var timeagoInstance = new _timeago2.default();
	        str = timeagoInstance.format(time, 'zh_CN');
	    }
	    return str;
	};
	
	/**
	 * 格式化日期或时间
	 * @param {string} time 需要格式化的时间
	 * @param {bool} friendly 是否是fromNow
	 */
	exports.getLastTimeStr = function (time, friendly) {
	    if (friendly) {
	        return MillisecondToDate(time);
	    } else {
	        return fmtDate(new Date(time), 'yyyy-MM-dd hh:mm');
	    }
	};
	
	/**
	 * 获取不同tab的信息
	 * @param  {[type]}  tab     [tab分类]
	 * @param  {[type]}  good    [是否是精华]
	 * @param  {[type]}  top     [是否置顶]
	 * @param  {Boolean} isClass [是否是样式]
	 * @return {[type]}          [返回对应字符串]
	 */
	exports.getTabInfo = function (tab, good, top, isClass) {
	    var str = '';
	    var className = '';
	    if (top) {
	        str = '置顶';
	        className = 'top';
	    } else if (good) {
	        str = '精华';
	        className = 'good';
	    } else {
	        switch (tab) {
	            case 'share':
	                str = '分享';
	                className = 'share';
	                break;
	            case 'ask':
	                str = '问答';
	                className = 'ask';
	                break;
	            case 'job':
	                str = '招聘';
	                className = 'job';
	                break;
	            default:
	                str = '暂无';
	                className = 'default';
	                break;
	        }
	    }
	    return isClass ? className : str;
	};
	
	/**
	 * 配置节流函数
	 * @param  {[Function]}  fn     [要执行的函数]
	 * @param  {[Number]}  delay    [延迟执行的毫秒数]
	 * @param  {[Number]}  mustRun  [至少多久执行一次]
	 * @return {[Function]}         [节流函数]
	 */
	exports.throttle = function (fn, wait, mustRun) {
	    var timeout = void 0;
	    var startTime = new Date();
	    return function () {
	        var context = this;
	        var args = arguments;
	        var curTime = new Date();
	
	        clearTimeout(timeout);
	        // 如果达到了规定的触发时间间隔，触发 handler
	        if (curTime - startTime >= mustRun) {
	            fn.apply(context, args);
	            startTime = curTime;
	            // 没达到触发间隔，重新设定定时器
	        } else {
	            timeout = setTimeout(fn, wait);
	        }
	    };
	};
	
	exports.linkUsers = linkUsers;
	exports.fetchUsers = fetchUsers;
	exports.getCheck = getCheck;
	exports.fmtDate = fmtDate;
	exports.parseDate = parseDate;
	exports.getAge = getAge;
	exports.MillisecondToDate = MillisecondToDate;

/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(89);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(406);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var userStore = new _vuex2.default.Store({
	    state: {
	        userInfo: {},
	        demoInfo: {}
	    },
	    getters: {
	        getUserInfo: function getUserInfo(state) {
	            return state.userInfo;
	        }
	    },
	    mutations: {
	        setUserInfo: function setUserInfo(state, userInfo) {
	            state.userInfo = userInfo;
	        },
	        setDemoInfo: function setDemoInfo(state, demoInfo) {
	            state.demoInfo = demoInfo;
	        }
	    },
	    actions: {
	        setUserInfo: function setUserInfo(_ref, user) {
	            var commit = _ref.commit;
	
	            commit('setUserInfo', user);
	        }
	    }
	});
	exports.default = userStore;

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _utils = __webpack_require__(37);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** 格式化时间
	 *  @param {string} time 需要格式化的时间
	 *  @param {bool} friendly 是否是fromNow
	 */
	exports.getLastTimeStr = function (time, friendly) {
	    if (friendly) {
	        return _utils2.default.MillisecondToDate(time);
	    } else {
	        return _utils2.default.fmtDate(new Date(time), 'yyyy-MM-dd hh:mm');
	    }
	};
	
	/** 获取文字标签
	 *  @param {string} tab Tab分类
	 *  @param {bool} good 是否是精华帖
	 *  @param {bool} top 是否是置顶帖
	 */
	exports.getTabStr = function (tab, good, top) {
	    var str = '';
	    if (top) {
	        str = '置顶';
	    } else if (good) {
	        str = '精华';
	    } else {
	        switch (tab) {
	            case 'share':
	                str = '分享';
	                break;
	            case 'ask':
	                str = '问答';
	                break;
	            case 'job':
	                str = '招聘';
	                break;
	            default:
	                str = '暂无';
	                break;
	        }
	    }
	    return str;
	};
	
	/** 获取标签样式
	 *  @param {string} tab Tab分类
	 *  @param {bool} good 是否是精华帖
	 *  @param {bool} top 是否是置顶帖
	 */
	exports.getTabClassName = function (tab, good, top) {
	    var className = '';
	
	    if (top) {
	        className = 'top';
	    } else if (good) {
	        className = 'good';
	    } else {
	        switch (tab) {
	            case 'share':
	                className = 'share';
	                break;
	            case 'ask':
	                className = 'ask';
	                break;
	            case 'job':
	                className = 'job';
	                break;
	            default:
	                className = 'default';
	                break;
	        }
	    }
	    return className;
	};

/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(89);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _webpackZepto = __webpack_require__(20);
	
	var _webpackZepto2 = _interopRequireDefault(_webpackZepto);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * 全局注册弱提示
	 */
	exports.default = {
	    install: function install() {
	        var timer = null;
	        _vue2.default.prototype.$alert = function (msg) {
	            (0, _webpackZepto2.default)('#alertWeek').remove();
	            var $alert = (0, _webpackZepto2.default)('<div class="week-alert" id="alertWeek"></div>');
	            (0, _webpackZepto2.default)('body').append($alert);
	            $alert.html(msg);
	            $alert.addClass('alert-show');
	            clearTimeout(timer);
	            timer = setTimeout(function () {
	                $alert.remove();
	            }, 2000);
	        };
	    }
	};

/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Main = __webpack_require__(384);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Home = function Home(resolve) {
	    __webpack_require__.e/* nsure */(15, function () {
	        resolve(__webpack_require__(132));
	    });
	}; // require.ensure 是 Webpack 的特殊语法，用来设置 code-split point
	
	
	var BookList = function BookList(resolve) {
	    __webpack_require__.e/* nsure */(7, function () {
	        resolve(__webpack_require__(137));
	    });
	};
	
	var AddBook = function AddBook(resolve) {
	    __webpack_require__.e/* nsure */(8, function () {
	        resolve(__webpack_require__(136));
	    });
	};
	var AddSong = function AddSong(resolve) {
	    __webpack_require__.e/* nsure */(14, function () {
	        resolve(__webpack_require__(140));
	    });
	};
	var SongList = function SongList(resolve) {
	    __webpack_require__.e/* nsure */(5, function () {
	        resolve(__webpack_require__(143));
	    });
	};
	var SongInfo = function SongInfo(resolve) {
	    __webpack_require__.e/* nsure */(6, function () {
	        resolve(__webpack_require__(142));
	    });
	};
	var SongAsl = function SongAsl(resolve) {
	    __webpack_require__.e/* nsure */(1, function () {
	        resolve(__webpack_require__(141));
	    });
	};
	var AddTeacher = function AddTeacher(resolve) {
	    __webpack_require__.e/* nsure */(9, function () {
	        resolve(__webpack_require__(145));
	    });
	};
	var TeacherList = function TeacherList(resolve) {
	    __webpack_require__.e/* nsure */(3, function () {
	        resolve(__webpack_require__(147));
	    });
	};
	var TeacherInfo = function TeacherInfo(resolve) {
	    __webpack_require__.e/* nsure */(4, function () {
	        resolve(__webpack_require__(146));
	    });
	};
	var TaskList = function TaskList(resolve) {
	    __webpack_require__.e/* nsure */(0, function () {
	        resolve(__webpack_require__(144));
	    });
	};
	var BannerList = function BannerList(resolve) {
	    __webpack_require__.e/* nsure */(12, function () {
	        resolve(__webpack_require__(135));
	    });
	};
	var PictureList = function PictureList(resolve) {
	    __webpack_require__.e/* nsure */(11, function () {
	        resolve(__webpack_require__(138));
	    });
	};
	var AppVersions = function AppVersions(resolve) {
	    __webpack_require__.e/* nsure */(13, function () {
	        resolve(__webpack_require__(134));
	    });
	};
	var JPushAdd = function JPushAdd(resolve) {
	    __webpack_require__.e/* nsure */(10, function () {
	        resolve(__webpack_require__(139));
	    });
	};
	
	var routers = [{
	    path: '/',
	    component: Home,
	    name: '首页',
	    iconCls: 'el-icon-setting',
	    meta: { requiresAuth: true, authName: 'index' },
	    children: [{ path: '/main', component: _Main2.default, name: '主页', hidden: true, meta: { requiresAuth: true, authName: 'main' } }]
	}, {
	    path: '/',
	    component: Home,
	    name: '曲库管理',
	    iconCls: 'el-icon-message',
	    meta: { requiresAuth: true, authName: 'bookIndex' },
	    children: [{ path: '/book/add', component: AddBook, name: '添加教材', meta: { requiresAuth: true, authName: 'bookAdd' } }, { path: '/book/list', component: BookList, name: '教材列表', meta: { requiresAuth: true, authName: 'bookList' } }, { path: '/song/add/:bId', component: AddSong, hidden: true, name: '添加曲目', meta: { requiresAuth: true, authName: 'songAdd' } }, { path: '/song/info/:bId/:sId', component: SongInfo, hidden: true, name: '曲目信息', meta: { requiresAuth: true, authName: 'songInfo', backInfo: { backName: '返回曲目列表', backUrl: '' } } }, { path: '/song/list/:bId', component: SongList, hidden: true, name: '曲目列表', meta: { requiresAuth: true, authName: 'songList', backInfo: { backName: '返回教材管理', backUrl: '/book/list' } } }, {
	        path: '/song/asl',
	        component: SongAsl,
	        hidden: true,
	        name: '走谱信息',
	        meta: {
	            requiresAuth: true,
	            authName: 'songAsl',
	            backInfo: { backName: '返回曲目管理', backUrl: '' }
	        }
	    }]
	}, {
	    path: '/',
	    component: Home,
	    name: '名师管理',
	    iconCls: 'el-icon-star-on',
	    meta: { requiresAuth: true, authName: 'tchIndex' },
	    children: [{ path: '/teacher/add', component: AddTeacher, name: '添加名师', meta: { requiresAuth: true, authName: 'tchAdd' } }, { path: '/teacher/list', component: TeacherList, name: '名师列表', meta: { requiresAuth: true, authName: 'tchList' } }, { path: '/teacher/info/:tchId', component: TeacherInfo, hidden: true, name: '名师信息', meta: { requiresAuth: true, authName: 'tchInfo', backInfo: { backName: '返回名师管理', backUrl: '/teacher/list' } } }]
	}, {
	    path: '/',
	    component: Home,
	    name: '广告位管理',
	    iconCls: 'el-icon-star-on',
	    meta: { requiresAuth: true, authName: 'bannerIndex' },
	    leaf: true,
	    children: [{ path: '/banner/list', component: BannerList, name: '广告位信息', meta: { requiresAuth: true, authName: 'bannerList' } }]
	}, {
	    path: '/',
	    component: Home,
	    name: '图片管理',
	    iconCls: 'el-icon-star-on',
	    meta: { requiresAuth: true, authName: 'pictureIndex' },
	    leaf: true,
	    children: [{ path: '/picture/list', component: PictureList, name: '图片信息', meta: { requiresAuth: true, authName: 'pictureList' } }]
	}, {
	    path: '/',
	    component: Home,
	    name: 'App版本管理',
	    iconCls: 'el-icon-star-on',
	    meta: { requiresAuth: true, authName: 'appVersionIndex' },
	    leaf: true,
	    children: [{ path: '/app/version/list', component: AppVersions, name: 'App版本信息', meta: { requiresAuth: true, authName: 'appVersionList' } }]
	}, {
	    path: '/',
	    component: Home,
	    name: '推送管理',
	    iconCls: 'el-icon-star-on',
	    meta: { requiresAuth: true, authName: 'jpushIndex' },
	    leaf: true,
	    children: [{ path: '/jpush/add', component: JPushAdd, name: '推送信息', meta: { requiresAuth: true, authName: 'jpushAdd' } }]
	}, {
	    path: '/',
	    component: Home,
	    name: '任务管理',
	    iconCls: 'el-icon-time',
	    meta: { requiresAuth: true, authName: 'taskIndex' },
	    leaf: true,
	    children: [{ path: '/task/list', component: TaskList, name: '任务列表', meta: { requiresAuth: true, authName: 'taskList' } }]
	}, {
	    path: '/login',
	    name: '登录',
	    hidden: true,
	    component: function component(resolve) {
	        __webpack_require__.e/* nsure */(2, function () {
	            resolve(__webpack_require__(133));
	        });
	    }
	}, {
	    path: '*',
	    hidden: true,
	    component: Home
	}];
	
	exports.default = routers;

/***/ }),

/***/ 152:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	//
	//
	//
	//
	//
	
	exports.default = {
	    name: 'app',
	    components: {}
	};

/***/ }),

/***/ 155:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	//
	//
	//
	//
	//
	//
	
	exports.default = {};

/***/ }),

/***/ 181:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 182:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 184:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 196:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 383:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(196)
	
	var Component = __webpack_require__(19)(
	  /* script */
	  __webpack_require__(152),
	  /* template */
	  __webpack_require__(399),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 384:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(184)
	
	var Component = __webpack_require__(19)(
	  /* script */
	  __webpack_require__(155),
	  /* template */
	  __webpack_require__(386),
	  /* scopeId */
	  "data-v-1fd7a80e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 386:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', [_vm._v("\n    main\n")])
	},staticRenderFns: []}

/***/ }),

/***/ 399:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// public/js/app.2ca668cacbe7756289a6.js